import type { AsyncStorage } from "@solid-primitives/storage"

const ACCESS_TOKEN_KEY = "desktop_access_token"
const REFRESH_TOKEN_KEY = "desktop_refresh_token"

let store: AsyncStorage | null = null

export function configureDesktopTokenStore(storage: AsyncStorage): void {
  store = storage
}

export async function getStoredAccessToken(): Promise<string | null> {
  if (!store) return null
  const value = await store.getItem(ACCESS_TOKEN_KEY)
  return value ?? null
}

export async function getStoredRefreshToken(): Promise<string | null> {
  if (!store) return null
  const value = await store.getItem(REFRESH_TOKEN_KEY)
  return value ?? null
}

export async function setStoredTokens(access: string, refresh: string): Promise<void> {
  if (!store) return
  await store.setItem(ACCESS_TOKEN_KEY, access)
  await store.setItem(REFRESH_TOKEN_KEY, refresh)
}

export async function clearStoredTokens(): Promise<void> {
  if (!store) return
  await store.removeItem(ACCESS_TOKEN_KEY)
  await store.removeItem(REFRESH_TOKEN_KEY)
  if ("flush" in store && typeof (store as { flush?: unknown }).flush === "function") {
    await ((store as unknown as { flush: () => Promise<void> }).flush())
  }
}
